import * as React from 'react';

class Footer extends React.Component {
  render() {
    return (
      /* 必要な場合に後で追加する */
      false
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.tsx